/* stellar-header.js — sheets (hover intent, click, keyboard), category panels, media autoplay,
   find bar (Shopify predictive search + page index), phone drawer, cart count, theme-editor hooks. */
(function () {
  'use strict';
  if (window.__sxhInit) return; window.__sxhInit = true;

  var FINE = matchMedia('(hover:hover) and (pointer:fine)');
  var REDUCED = matchMedia('(prefers-reduced-motion:reduce)');
  var conn = navigator.connection || {};
  var SAVE = !!conn.saveData || conn.type === 'cellular' || /^(slow-2g|2g|3g)$/.test(conn.effectiveType || '');

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function hi(s, q) {
    if (!q) return esc(s);
    var rx = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
    return esc(s).replace(rx, '<mark>$1</mark>');
  }

  /* ——— media: play what is visible, pause what is not; tap mark where autoplay is blocked ——— */
  function armVideo(v) {
    if (v.dataset.sxhArmed) return; v.dataset.sxhArmed = '1';
    v.muted = true; v.loop = true; v.setAttribute('playsinline', '');
    var slot = v.closest('[data-slot]'), tap = slot && slot.querySelector('.sxh-tap');
    v.addEventListener('playing', function () { v.classList.add('is-ready'); if (tap) tap.hidden = true; });
    v.addEventListener('pause', function () { if (!v.ended && tap && v.dataset.sxhWant === '1') tap.hidden = false; });
    if (tap) tap.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); playVideo(v); });
  }
  function playVideo(v) {
    armVideo(v); v.dataset.sxhWant = '1';
    var slot = v.closest('[data-slot]'), tap = slot && slot.querySelector('.sxh-tap');
    if (SAVE) { if (tap) tap.hidden = false; return; }
    var p = v.play(); if (p && p.then) p.then(function () { if (tap) tap.hidden = true; }, function () { if (tap) tap.hidden = false; });
  }
  function pauseVideo(v) { v.dataset.sxhWant = '0'; if (!v.paused) v.pause(); }
  function syncMedia(sheet) {
    if (!sheet) return;
    sheet.querySelectorAll('video.sxh-vid').forEach(function (v) {
      var panel = v.closest('.sxh-panel');
      var visible = sheet.classList.contains('is-open') && (!panel || !panel.hidden);
      if (visible) playVideo(v); else pauseVideo(v);
    });
  }

  /* ——— shooting stars in empty media boxes (the site's only background motion) ——— */
  function stars(cv) {
    if (cv.dataset.sxhStars || REDUCED.matches) return; cv.dataset.sxhStars = '1';
    var ctx = cv.getContext('2d'), W, H, dots = [], shots = [], last = 0, dpr = Math.min(devicePixelRatio || 1, 2);
    function size() {
      var r = cv.getBoundingClientRect(); W = cv.width = Math.max(1, r.width * dpr); H = cv.height = Math.max(1, r.height * dpr);
      dots = []; for (var i = 0; i < 70; i++) dots.push({ x: Math.random() * W, y: Math.random() * H, r: (Math.random() * .9 + .3) * dpr, a: Math.random() });
    }
    if ('ResizeObserver' in window) new ResizeObserver(size).observe(cv); size();
    function tick(t) {
      if (!cv.isConnected) return; requestAnimationFrame(tick);
      var sheet = cv.closest('.sxh-sheet'), panel = cv.closest('.sxh-panel');
      if ((sheet && !sheet.classList.contains('is-open')) || (panel && panel.hidden)) return;
      ctx.clearRect(0, 0, W, H);
      dots.forEach(function (s) { s.a += (Math.random() - .5) * .05; s.a = Math.min(1, Math.max(.15, s.a)); ctx.globalAlpha = s.a * .55; ctx.fillStyle = '#F1EAC9'; ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, 7); ctx.fill(); });
      if (t - last > 2600 + Math.random() * 3000) { last = t; shots.push({ x: Math.random() * W * .8, y: Math.random() * H * .4, vx: (6 + Math.random() * 4) * dpr, vy: (2.5 + Math.random() * 2) * dpr, l: 1 }); }
      shots = shots.filter(function (s) { return s.l > 0; });
      shots.forEach(function (s) {
        ctx.globalAlpha = s.l * .9; var g = ctx.createLinearGradient(s.x, s.y, s.x - s.vx * 10, s.y - s.vy * 10);
        g.addColorStop(0, '#F1EAC9'); g.addColorStop(1, 'rgba(241,234,201,0)'); ctx.strokeStyle = g; ctx.lineWidth = 1.2 * dpr;
        ctx.beginPath(); ctx.moveTo(s.x, s.y); ctx.lineTo(s.x - s.vx * 10, s.y - s.vy * 10); ctx.stroke(); s.x += s.vx; s.y += s.vy; s.l -= .02;
      });
      ctx.globalAlpha = 1;
    }
    requestAnimationFrame(tick);
  }

  /* ——— one header ——— */
  function init(root) {
    if (!root || root.dataset.sxhReady) return; root.dataset.sxhReady = '1';
    var section = root.closest('.shopify-section') || root.parentElement;
    var veil = section.querySelector('[data-veil]');
    var drawer = section.querySelector('[data-drawer]');
    var lbls = Array.prototype.slice.call(root.querySelectorAll('.sxh__lbl[data-sheet]'));
    var sheets = Array.prototype.slice.call(root.querySelectorAll('.sxh-sheet'));
    var open = null, openT, closeT, findOpen = false;

    root.querySelectorAll('[data-stars]').forEach(stars);
    root.querySelectorAll('video.sxh-vid').forEach(armVideo);

    /* category panels */
    root.querySelectorAll('.sxh-sheet[data-kind="spirits"]').forEach(function (sheet) {
      var cats = sheet.querySelector('[data-cats]'); if (!cats) return;
      var items = Array.prototype.slice.call(cats.querySelectorAll('li[data-cat]'));
      function setCat(id) {
        items.forEach(function (li) { li.classList.toggle('on', li.dataset.cat === id); });
        sheet.querySelectorAll('.sxh-panel').forEach(function (p) { p.hidden = p.dataset.panel !== id; });
        syncMedia(sheet);
      }
      sheet.setCat = setCat;
      var t;
      cats.addEventListener('pointerover', function (e) { var li = e.target.closest('li[data-cat]'); if (!li) return; clearTimeout(t); t = setTimeout(function () { setCat(li.dataset.cat); }, 40); });
      cats.addEventListener('focusin', function (e) { var li = e.target.closest('li[data-cat]'); if (li) setCat(li.dataset.cat); });
      cats.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return; e.preventDefault();
        var links = items.map(function (li) { return li.querySelector('a'); }); var i = links.indexOf(document.activeElement);
        var n = links[(i + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length]; if (n) n.focus();
      });
      if (items[0]) setCat(items[0].dataset.cat);
    });

    /* sheets */
    function openSheet(id) {
      clearTimeout(closeT); if (open === id) return; closeFind(false);
      lbls.forEach(function (b) { var on = b.dataset.sheet === id; b.classList.toggle('is-open', on); b.closest('li').classList.toggle('on', on); b.setAttribute('aria-expanded', on); });
      sheets.forEach(function (s) { s.classList.toggle('is-open', s.id === id); });
      if (veil) veil.classList.add('is-on'); open = id;
      syncMedia(document.getElementById(id));
      sheets.forEach(function (s) { if (s.id !== id) syncMedia(s); });
    }
    function closeSheet() {
      clearTimeout(openT); if (!open) return;
      lbls.forEach(function (b) { b.classList.remove('is-open'); b.closest('li').classList.remove('on'); b.setAttribute('aria-expanded', 'false'); });
      sheets.forEach(function (s) { s.classList.remove('is-open'); syncMedia(s); });
      if (veil && !findOpen) veil.classList.remove('is-on'); open = null;
    }
    lbls.forEach(function (b) {
      b.addEventListener('click', function () { open === b.dataset.sheet ? closeSheet() : openSheet(b.dataset.sheet); });
      b.addEventListener('pointerenter', function (e) { if (!FINE.matches || e.pointerType === 'touch') return; clearTimeout(closeT); openT = setTimeout(function () { openSheet(b.dataset.sheet); }, 70); });
      b.addEventListener('pointerleave', function () { clearTimeout(openT); });
    });
    root.querySelectorAll('.sxh__lbl:not([data-sheet])').forEach(function (a) {
      a.addEventListener('pointerenter', function (e) { if (!FINE.matches || e.pointerType === 'touch') return; clearTimeout(openT); closeT = setTimeout(closeSheet, 120); });
    });
    root.addEventListener('pointerleave', function (e) { if (!FINE.matches || e.pointerType === 'touch') return; closeT = setTimeout(closeSheet, 160); });
    root.addEventListener('pointerenter', function () { clearTimeout(closeT); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget) && !findOpen) closeSheet(); });
    if (veil) veil.addEventListener('click', function () { closeSheet(); closeFind(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeSheet(); closeFind(); closeDrawer(true); }
      if (e.key === '/' && !/input|textarea|select/i.test(document.activeElement.tagName) && !document.activeElement.isContentEditable && matchMedia('(min-width:1000px)').matches) { e.preventDefault(); openFind(); }
    });

    /* find */
    var find = root.querySelector('[data-find]'), findInput = root.querySelector('[data-find-input]'), findRes = root.querySelector('[data-find-results]');
    var findBtn = root.querySelector('[data-find-open]'), findSheet = root.querySelector('#sxh-sheet-find');
    var idxEl = root.querySelector('[data-find-index]'), IDX = null;
    try { IDX = idxEl ? JSON.parse(idxEl.textContent) : null; } catch (err) { IDX = null; }
    var reqSeq = 0;
    function col(k, items, mute) { return '<div class="sxh-col"><span class="k' + (mute ? ' mute' : '') + '">' + esc(k) + '</span>' + (items.length ? '<ul class="sxh-links" data-focus>' + items.join('') + '</ul>' : '<p class="sxh-empty">' + esc(IDX.labels.empty) + '</p>') + '</div>'; }
    function row(t, u, k, q) { return '<li><a href="' + esc(u) + '"><span>' + hi(t, q) + '</span><span>' + esc(k) + '</span></a></li>'; }
    /* render(q, target): the find sheet on desktop, the drawer's results box on phones */
    function render(q, target) {
      target = target || findRes;
      if (!target || !IDX) return; q = (q || '').trim();
      if (!q) {
        target.innerHTML = col('Pour something', IDX.pours.map(function (p) { return row(p.t, p.u, p.k, ''); }), true)
          + col('Ways in', IDX.ways.map(function (p) { return row(p.t, p.u, p.k, ''); }), true)
          + col('Go straight to', IDX.pages.slice(0, 5).map(function (p) { return row(p.t, p.u, p.k, ''); }), true);
        return;
      }
      var ql = q.toLowerCase();
      var pages = IDX.pages.filter(function (p) { return p.t.toLowerCase().indexOf(ql) > -1; }).slice(0, 6).map(function (p) { return row(p.t, p.u, p.k, q); });
      var seq = ++reqSeq;
      var url = IDX.suggest_url + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8&resources[options][fields]=title,product_type,vendor,tag';
      fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        if (seq !== reqSeq) return;
        var res = (j && j.resources && j.resources.results) || {};
        var prods = (res.products || []).map(function (p) { return row(p.title, p.url, p.type || p.vendor || IDX.labels.spirits, q); });
        var cols = (res.collections || []).map(function (c) { return row(c.title, c.url, IDX.labels.collection, q); });
        target.innerHTML = col(IDX.labels.pour, prods) + col(IDX.labels.ways, cols) + col(IDX.labels.pages, pages);
      }).catch(function () {
        if (seq !== reqSeq) return;
        target.innerHTML = col(IDX.labels.pour, [row('Search “' + q + '”', IDX.search_url + '?q=' + encodeURIComponent(q), IDX.labels.spirits, '')]) + col(IDX.labels.ways, []) + col(IDX.labels.pages, pages);
      });
    }
    function openFind() {
      if (findOpen || !find) return; closeSheet(); findOpen = true; find.hidden = false;
      if (findBtn) findBtn.setAttribute('aria-expanded', 'true');
      if (findSheet) findSheet.classList.add('is-open'); if (veil) veil.classList.add('is-on');
      findInput.value = ''; render(''); findInput.focus();
    }
    function closeFind(refocus) {
      if (!findOpen) return; findOpen = false; find.hidden = true;
      if (findBtn) findBtn.setAttribute('aria-expanded', 'false');
      if (findSheet) findSheet.classList.remove('is-open'); if (veil && !open) veil.classList.remove('is-on');
      if (refocus !== false && findBtn) findBtn.focus();
    }
    if (findBtn) findBtn.addEventListener('click', function () {
      if (matchMedia('(max-width:999px)').matches) { openDrawer(true); return; }
      findOpen ? closeFind() : openFind();
    });
    var findClose = root.querySelector('[data-find-close]'); if (findClose) findClose.addEventListener('click', function () { closeFind(); });
    if (findInput) {
      var deb; findInput.addEventListener('input', function () { clearTimeout(deb); deb = setTimeout(function () { render(findInput.value); }, 120); });
      findInput.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return; e.preventDefault();
        var a = findRes && findRes.querySelector('a'); var q = findInput.value.trim();
        location.href = a ? a.href : (IDX.search_url + '?q=' + encodeURIComponent(q));
      });
    }

    /* ——— phone drawer ———
       Closed until the menu button is tapped. The same button closes it (its three lines turn into an X).
       The panel glides in from the left below the bar; the page beside it dims and closes it on tap. */
    var menuBtn = root.querySelector('[data-drawer-open]');
    var dveil = section.querySelector('[data-drawer-veil]');
    var drawerOpen = false, drawerT;
    var DRAWER_MS = 560, SUB_MS = 580;

    if (menuBtn) {
      /* three separate lines, so they can move independently (older markup had one path) */
      var ic = menuBtn.querySelector('svg');
      if (ic && !ic.querySelector('.sxh-bar')) {
        ic.setAttribute('viewBox', '0 0 24 24');
        ic.innerHTML = '<path class="sxh-bar" d="M2 5h20"/><path class="sxh-bar" d="M2 12h20"/><path class="sxh-bar" d="M2 19h20"/>';
      }
    }
    if (drawer && !dveil) { dveil = document.createElement('div'); dveil.className = 'sxh-dveil'; dveil.setAttribute('data-drawer-veil', ''); drawer.parentNode.insertBefore(dveil, drawer); }

    function placeBelowBar() {
      var top = Math.max(0, Math.round(root.getBoundingClientRect().bottom)) + 'px';
      drawer.style.setProperty('--sxh-top', top);
      if (dveil) dveil.style.setProperty('--sxh-top', top);
    }
    function openDrawer(focusFind) {
      if (!drawer) return;
      var inp = drawer.querySelector('[data-drawer-input]');
      if (drawerOpen) { if (focusFind && inp) inp.focus(); return; }
      clearTimeout(drawerT); drawerOpen = true;
      placeBelowBar();
      drawer.hidden = false;
      void drawer.offsetHeight; /* paint the closed position first, then glide */
      drawer.classList.remove('is-closing'); drawer.classList.add('is-open');
      if (dveil) dveil.classList.add('is-on');
      if (menuBtn) { menuBtn.setAttribute('aria-expanded', 'true'); menuBtn.setAttribute('aria-label', 'Close menu'); }
      document.documentElement.classList.add('sxh-lock');
      if (focusFind && inp) setTimeout(function () { inp.focus(); }, REDUCED.matches ? 0 : 400);
    }
    function closeDrawer(refocus) {
      if (!drawer || !drawerOpen) return;
      drawerOpen = false;
      drawer.classList.add('is-closing'); drawer.classList.remove('is-open');
      if (dveil) dveil.classList.remove('is-on');
      if (menuBtn) { menuBtn.setAttribute('aria-expanded', 'false'); menuBtn.setAttribute('aria-label', 'Open menu'); }
      document.documentElement.classList.remove('sxh-lock');
      clearTimeout(drawerT);
      drawerT = setTimeout(function () { drawer.hidden = true; drawer.classList.remove('is-closing'); }, REDUCED.matches ? 0 : DRAWER_MS);
      if (refocus && menuBtn) menuBtn.focus(); /* keyboard close only, so a tap leaves no focus ring */
    }
    if (menuBtn) menuBtn.addEventListener('click', function () { drawerOpen ? closeDrawer(false) : openDrawer(false); });
    if (dveil) dveil.addEventListener('click', function () { closeDrawer(false); });

    /* sub-lists unfold to their height, and fold back */
    function setSub(sub, on) {
      if (!sub) return;
      var was = sub.dataset.on === '1'; if (was === on) return;
      sub.dataset.on = on ? '1' : '0';
      clearTimeout(sub._t);
      if (on) {
        var from = sub.classList.contains('is-open') ? sub.offsetHeight : 0;
        sub.classList.add('is-open', 'is-out');
        sub.style.height = from + 'px';
        void sub.offsetHeight;
        sub.classList.remove('is-out');
        sub.style.height = sub.scrollHeight + 'px';
        sub._t = setTimeout(function () { sub.style.height = ''; }, SUB_MS);
      } else {
        sub.style.height = sub.offsetHeight + 'px';
        void sub.offsetHeight;
        sub.classList.add('is-out');
        sub.style.height = '0px';
        sub._t = setTimeout(function () { sub.classList.remove('is-open', 'is-out'); sub.style.height = ''; }, SUB_MS);
      }
    }
    if (drawer) {
      var dClose = drawer.querySelector('[data-drawer-close]'); if (dClose) dClose.addEventListener('click', function () { closeDrawer(false); });
      var rows = Array.prototype.slice.call(drawer.querySelectorAll('.sxh-dl__row[aria-controls]'));
      rows.forEach(function (b) {
        b.addEventListener('click', function () {
          var on = b.getAttribute('aria-expanded') !== 'true';
          rows.forEach(function (o) { if (o !== b) { o.setAttribute('aria-expanded', 'false'); setSub(document.getElementById(o.getAttribute('aria-controls')), false); } });
          b.setAttribute('aria-expanded', on);
          setSub(document.getElementById(b.getAttribute('aria-controls')), on);
        });
      });
      matchMedia('(min-width:1000px)').addEventListener('change', function (e) { if (e.matches) closeDrawer(false); });

      /* find inside the drawer: live results while typing, Enter goes to the search page */
      var dInput = drawer.querySelector('[data-drawer-input]');
      var dRes = drawer.querySelector('[data-drawer-results]');
      if (dInput && dRes && IDX) {
        var dDeb;
        dInput.addEventListener('input', function () {
          clearTimeout(dDeb);
          dDeb = setTimeout(function () {
            var q = dInput.value.trim();
            drawer.classList.toggle('is-finding', !!q);
            dRes.hidden = !q;
            if (q) render(q, dRes); else dRes.innerHTML = '';
          }, 120);
        });
      }
    }

    /* theme editor */
    root.sxh = {
      openSheet: openSheet, closeSheet: closeSheet,
      selectBlock: function (id) {
        var el = section.querySelector('[data-block-id="' + id + '"]'); if (!el) return;
        var sheet = el.closest('.sxh-sheet'); if (!sheet) return;
        openSheet(sheet.id);
        var cat = el.closest('li[data-cat]'); var panel = el.closest('.sxh-panel');
        if (cat && sheet.setCat) sheet.setCat(cat.dataset.cat);
        else if (panel && sheet.setCat) sheet.setCat(panel.dataset.panel);
      }
    };
  }

  /* ——— cart count: re-read the cart after any cart event the theme or apps fire ——— */
  var cartT;
  function refreshCart() {
    clearTimeout(cartT); cartT = setTimeout(function () {
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('[data-sxh-cart-count]').forEach(function (el) { el.textContent = c.item_count; if (el.classList.contains('sxh__count')) el.hidden = c.item_count === 0; });
      }).catch(function () {});
    }, 300);
  }
  ['cart:change', 'cart:refresh', 'cart:updated', 'cart:added', 'variant:added'].forEach(function (ev) { document.addEventListener(ev, refreshCart); });

  function boot() { document.querySelectorAll('[data-sxh]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-sxh]'); if (r) init(r); });
  document.addEventListener('shopify:block:select', function (e) { var r = e.target.closest('.shopify-section') && e.target.closest('.shopify-section').querySelector('[data-sxh]'); if (r && r.sxh && e.detail && e.detail.blockId) r.sxh.selectBlock(e.detail.blockId); });
  document.addEventListener('shopify:section:deselect', function (e) { var r = e.target.querySelector && e.target.querySelector('[data-sxh]'); if (r && r.sxh) r.sxh.closeSheet(); });
})();
